import { render, staticRenderFns } from "./editSubject.vue?vue&type=template&id=9b6a9d44&scoped=true&"
import script from "./editSubject.vue?vue&type=script&lang=js&"
export * from "./editSubject.vue?vue&type=script&lang=js&"
import style0 from "./editSubject.vue?vue&type=style&index=0&id=9b6a9d44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a9d44",
  null
  
)

export default component.exports